import { useState } from 'react'
import { useParams } from 'react-router-dom';
import CreateLogin from '../components/CreateLogin';
import Invite from '../components/Invite';
import Login from '../components/Login'
import Header from '../components/Header'
import Footer from '../components/Footer'

/**
 * InvitePage
 *
 * @returns {JSX.Element}
 * @constructor
 */
const InvitePage = () => {
  const [ showLogin, setShowLogin ] = useState(false);
  const [ showCreateLogin, setShowCreateLogin ] = useState(true);

  const params = useParams();
  const player = JSON.parse(localStorage.getItem('player'));

  // The stored player should always exist at this point
  if (player === null) {
    window.location = '/';
  }

  /**
   * onLoginLinkClick
   *
   * Handler for when the "I have a login" link is clicked. Toggles between the login and create login components.
   */
  const onLoginLinkClick = () => {
    setShowLogin(true);
    setShowCreateLogin(false);
  }

  return (
    <div className="page-wrap">
      <Header/>
      <div className="invite-page">
        {/*<div className="new-group">New Group</div>*/}
        <div className="new-group-copy">Invite your friends to play. Each day you will
          get {process.env.REACT_APP_DAILY_QUESTION_COUNT} new question{process.env.REACT_APP_DAILY_QUESTION_COUNT > 1 &&
            <span>s</span>} and can compare your scores.
        </div>
        <Invite groupGuid={params.groupGuid} subject={params.subject}/>
        {/*{showLogin && <CreateLogin/>}*/}
        {showCreateLogin &&
          <div>
            <CreateLogin/>
            <div className="link-button-wrap">
              <span className="link-button login-link" onClick={onLoginLinkClick}>I have a login</span>
            </div>
          </div>
        }
        {showLogin &&
          <Login/>
        }
      </div>
      <Footer/>
    </div>
  )
}

export default InvitePage;
